/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import ModuleOptions from "data/Prod/ModuleListOptions.json";
import { reactSelectStyle } from "Config/Config";

const SaveSurveyModal = ({
  afterModalClose,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t } = useTranslation(); //for translation

  const [name, setname] = useState("");
  const [code, setcode] = useState("");
  const [moduleValue, setModuleValue] = useState(null);
  const [moduleSlug, setModuleSlug] = useState("");
  const [componentInput, setComponentInput] = useState("");
  const [componentList, setComponentList] = useState([]);
  const [componentValue, setComponentValue] = useState(null);
  const [selectedUser, setselectedUser] = useState(null);
  const [selectedContact, setselectedContact] = useState(null);
  const [selectedEvent, setselectedEvent] = useState(null);
  const [selectedGroup, setselectedGroup] = useState(null);
  const [selectedChallenge, setselectedChallenge] = useState(null);
  const [selectedCourse, setselectedCourse] = useState(null);

  const [isPosting, setIsPosting] = useState(false);

  const [responseError, setResponseError] = useState("");

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = t("Name is required");
    }

    if (!code.trim()) {
      newErrors.code = t("Code is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for select module
  const moduleSelectionHandler = (val) => {
    if (val) {
      setModuleValue(val);
      setModuleSlug(val.value);
      if (val.value === "MOD_USER") {
        const userOption = [
          {
            label: `${userInfo.name} ${userInfo.surname}`,
            value: userInfo._id,
          },
        ];

        setComponentList(userOption);
      }
    } else {
      setModuleValue(null);
      setModuleSlug(val);
      setComponentInput("");
      setComponentList([]);
      setComponentValue(null);
      setselectedUser(null);
      setselectedContact(null);
      setselectedEvent(null);
      setselectedGroup(null);
      setselectedChallenge(null);
      setselectedCourse(null);
    }
  };

  //get componentlist
  const getComponentOptions = async () => {
    try {
      let requestUrl = url.API_BASE_URL;

      if (moduleSlug === "MOD_CONTACT") {
        requestUrl +=
          url.API_GET_ALL_CONTACTS_OPTIONS +
          `?token=${token}&userstring=${componentInput}`;
      }

      if (moduleSlug === "MOD_EVENT") {
        requestUrl +=
          url.API_GET_EVENT_LIST_OPTIONS +
          `?token=${token}&eventtitle=${componentInput}`;
      }

      if (moduleSlug === "MOD_GROUP") {
        requestUrl +=
          url.API_GET_ALL_GROUP_OPTIONS +
          `?token=${token}&groupstring=${componentInput}`;
      }

      if (moduleSlug === "MOD_CHALLENGE") {
        requestUrl +=
          url.API_GET_CHALLENGE_LIST_FOR_OPTIONS +
          `?token=${token}&filtertitle=${componentInput}`;
      }

      if (moduleSlug === "MOD_COURSE") {
        requestUrl +=
          url.API_GET_COURSE_LIST_FOR_OPTIONS +
          `?token=${token}&coursestring=${componentInput}`;
      }

      console.log(requestUrl);

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setComponentList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select component
  const componentSelectionHandler = (val) => {
    if (val) {
      setComponentValue(val);

      if (moduleSlug === "MOD_USER") {
        setselectedUser(val.value);
      }

      if (moduleSlug === "MOD_CONTACT") {
        setselectedContact(val.value);
      }

      if (moduleSlug === "MOD_EVENT") {
        setselectedEvent(val.value);
      }

      if (moduleSlug === "MOD_GROUP") {
        setselectedGroup(val.value);
      }

      if (moduleSlug === "MOD_CHALLENGE") {
        setselectedChallenge(val.value);
      }

      if (moduleSlug === "MOD_COURSE") {
        setselectedCourse(val.value);
      }
    } else {
      setComponentValue(null);
      setComponentInput("");
      setComponentList([]);
      setselectedUser(null);
      setselectedContact(null);
      setselectedEvent(null);
      setselectedGroup(null);
      setselectedChallenge(null);
      setselectedCourse(null);
    }
  };

  //function for add new survey
  const saveSurveyHandler = async () => {
    if (!validateForm()) {
      setMessageType("error");
      setAlertMessage("Please fill up the required fields");
      return;
    }

    try {
      setIsPosting(true);

      let surveyData = {
        moduleslug: moduleSlug,
        name,
        code,
        user: null, // user means survey about this user.Must be an app user
        lead: null,
        contact: null,
        event: null,
        group: null,
        course: null,
        challenge: null,
      };

      if (moduleSlug === "MOD_USER") {
        surveyData.user = selectedUser;
      }

      if (moduleSlug === "MOD_CONTACT") {
        surveyData.contact = selectedContact;
      }

      if (moduleSlug === "MOD_EVENT") {
        surveyData.event = selectedEvent;
      }

      if (moduleSlug === "MOD_GROUP") {
        surveyData.group = selectedGroup;
      }

      if (moduleSlug === "MOD_CHALLENGE") {
        surveyData.challenge = selectedChallenge;
      }

      if (moduleSlug === "MOD_COURSE") {
        surveyData.course = selectedCourse;
      }

      console.log(surveyData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      requestUrl += url.API_ADD_NEW_SURVEY + `?token=${token}`;
      response = await postData(requestUrl, surveyData);

      console.log(response);

      setIsPosting(false);

      if (response.status) {
        setResponseError("");
        resetHandler();
        //hide survey modal
        let bootstrapModal = document.querySelector("#saveSurveyModal");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        //show success modal
        let myModal = new bootstrap.Modal(
          document.getElementById("surveySuccessModal")
        );
        myModal.show();
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setResponseError(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }

    setShowAlert(true);
  };

  //function for reset
  const resetHandler = () => {
    setResponseError("");
    setname("");
    setcode("");
    setModuleValue(null);
    setModuleSlug("");
    setComponentInput("");
    setComponentList([]);
    setComponentValue(null);
    setselectedUser(null);
    setselectedContact(null);
    setselectedEvent(null);
    setselectedGroup(null);
    setselectedChallenge(null);
    setselectedCourse(null);
    setErrors({});
  };

  useEffect(() => {
    if (moduleValue && moduleValue.value === "MOD_USER") {
      componentSelectionHandler({
        label: `${userInfo.name} ${userInfo.surname}`,
        value: userInfo._id,
      });
    }
  }, [moduleValue]);

  useEffect(() => {
    if (moduleSlug !== "" && componentInput !== "") {
      getComponentOptions();
    }
  }, [moduleSlug, componentInput]);

  return (
    <div
      className="modal fade"
      id="saveSurveyModal"
      tabIndex="-1"
      aria-labelledby="saveSurveyModal"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  save
                </span>
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Save Survey")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Save a new survey")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="name"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Survey name")}
                  </label>
                  <input
                    type="text"
                    placeholder={t("e.g., Customer Satisfaction Survey")}
                    className={`form-control fs-sm shadow-none ${
                      errors.name ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={name}
                    onChange={(e) => {
                      setname(e.target.value);
                      setResponseError("");
                      if (errors.name) {
                        setErrors((prev) => ({ ...prev, name: "" }));
                      }
                    }}
                  />

                  {errors.name && (
                    <div className="invalid-feedback d-block">
                      {t("Survey name is required.")}
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                {/* ----- code select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="Code"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Survey Code")}
                  </label>
                  <input
                    type="text"
                    placeholder={t("e.g., CUST-SAT-2024")}
                    className={`form-control fs-sm shadow-none ${
                      errors.code ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={code}
                    onChange={(e) => {
                      setcode(e.target.value);
                      setResponseError("");
                      if (errors.code) {
                        setErrors((prev) => ({ ...prev, code: "" }));
                      }
                    }}
                  />
                  {errors.code && (
                    <div className="invalid-feedback d-block">
                      {t("Survey code is required and must be unique.")}
                    </div>
                  )}
                </div>
                {/* ----- code select section end ----- */}

                {/* <!-- ========== Start module select Section ========== --> */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="Code"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Module")}
                  </label>
                  <Select
                    isClearable
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    options={ModuleOptions}
                    placeholder={t("Choose a module")}
                    value={moduleValue}
                    onChange={(val) => {
                      setResponseError("");
                      moduleSelectionHandler(val);
                    }}
                    menuPlacement="top"
                  />
                </div>
                {/* <!-- ========== End module select Section ========== --> */}

                {/* <!-- ========== Start component Section ========== --> */}
                {moduleValue ? (
                  <div className="form-group mb-4">
                    <label
                      htmlFor="Code"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Component")}
                    </label>
                    <Select
                      isClearable
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Search by name or email")}
                      options={componentList}
                      value={componentValue}
                      onChange={(val) => {
                        setResponseError("");
                        componentSelectionHandler(val);
                      }}
                      onInputChange={(val) => {
                        if (moduleSlug !== "MOD_USER") {
                          setResponseError("");
                          setComponentInput(val);
                        }
                      }}
                      menuPlacement="top"
                    />
                  </div>
                ) : null}
                {/* <!-- ========== End component Section ========== --> */}

                {/* ----- button section start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  {responseError && (
                    <p className="fw-bold text-danger mb-0 me-3">
                      * {responseError}
                    </p>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={saveSurveyHandler}
                    disabled={isPosting}
                    style={{
                      cursor: isPosting ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="material-symbols-outlined me-1">save</span>
                    {t("Save Survey")}
                    {isPosting && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
                {/* ----- button section end ----- */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveSurveyModal;
